import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import TotalBilledicon from "../../../images/icons/report-total-billed.svg";
import typeOfContract from '../../../constants/typeOfContract';
import { totalInvoiced } from '../ReportingOverview/Services/reportOverview.js';

// Functional component
function TotalBilled(props) {
  const [displayedAmount, setDisplayedAmount] = useState(0);
  const [targetAmount, setTargetAmount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const animationFrameRef = useRef(null);

  const reportingOverview = useSelector((state) => state.reportingOverview);
  const { forex } = useSelector((state) => state.forex);
  const settings = JSON.parse(localStorage.getItem("settings"));
  const clientInvoices = props.clientInvoices;
  const dashboardCurrencySum = useSelector((state) => state.invoice.dashboardCurrencySum);
  const setReportingCurrency = useSelector((state) => state.reportingOverview.currency);
  var currencies = "USD";
  if (setReportingCurrency && setReportingCurrency.length === 1) {
    currencies = setReportingCurrency[0];
  } else {
    currencies = settings.currency;
  }

  const invoiceTotal = totalInvoiced(clientInvoices, reportingOverview, currencies, forex);

  useEffect(() => {
    const parsedAmount = parseFloat(invoiceTotal) || 0;
    setTargetAmount(parsedAmount);
  }, [invoiceTotal, clientInvoices, reportingOverview, currencies, forex]);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    // Cancel any existing animation
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    const startValue = displayedAmount;
    const endValue = targetAmount;
    const duration = 1000; // Animation duration in milliseconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      const currentValue = startValue + (endValue - startValue) * easeOut;
      setDisplayedAmount(parseFloat(currentValue.toFixed(2)));

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayedAmount(endValue);
        animationFrameRef.current = null;
      }
    };

    if (Math.abs(startValue - endValue) > 0.01) {
      animationFrameRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [targetAmount]);

  return (
    <div style={{ 
      opacity: isVisible ? 1 : 0,
      transition: 'opacity 0.5s ease-in'
    }}>
      <div className="overview-item">
        <div className="overview-title-outer">
          <div className="overview-title">Total Billed</div>
          <div className="overview-icon">
            <img src={TotalBilledicon} alt="cLock" />
          </div>
        </div>
        <div className="overview-rice">
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currencies || "USD",
          }).format(displayedAmount)}
        </div>
      </div>
    </div>
  );
}

export default TotalBilled;